import { gql } from 'graphql-request'
import type { DeleteType } from '@/components/lib/GwDeleteDialog/GwDeleteDialog.vue'
import { filteredBy, type FilterParams } from './queries'
import type { ID } from '../../../../types/basic'
import { graphQLClient } from '../../gqlClient'

const deleteHandsQuery = (filters: FilterParams) => gql`
  mutation Delete_hands {
    delete_hands(${filteredBy(filters)})
  }
`

export const deleteHandsMutation = async ({
  deleteType,
  selectedItems,
  activeFilters,
}: {
  deleteType: DeleteType
  selectedItems: ID[]
  activeFilters: FilterParams
}) => {
  const filters =
    deleteType === 'all'
      ? activeFilters
      : ([
          {
            filter: {
              field_name: 'hand_id',
              api_filters: [
                {
                  field_name: 'hand_id__in',
                  filter_type: 'MULTIPLE_CHOICE',
                  predefined_value: selectedItems,
                  id: 'hand_id',
                  type: 'STRING',
                },
              ],
            },
          },
        ] as FilterParams)

  return graphQLClient.request(deleteHandsQuery(filters))
}

const updateHandColorQuery = (handIds: ID[], colorHex: string) => gql`
  mutation {
    update_hands_color_hex(
      filtered_by: { hand_id__in: ${JSON.stringify(handIds)} },
      color_hex: "${colorHex}"
    )
  }
`

export const updateHandColorMutation = async (handIds: ID[], colorHex: string) =>
  graphQLClient.request(updateHandColorQuery(handIds, colorHex))

const updateHandNoteQuery = (handIds: ID[], note: string) => gql`
  mutation {
    update_hands_note(
      filtered_by: { hand_id__in: ${JSON.stringify(handIds)} },
      note: "${note.replaceAll('\n', '\\n')}"
    )
  }
`

export const updateHandNoteMutation = (handIds: ID[], note: string) =>
  graphQLClient.request(updateHandNoteQuery(handIds, note))
